<script>
	let mobileMenuOpen = false;

	function toggleMobileMenu() {
		mobileMenuOpen = !mobileMenuOpen;
	}
</script>

<header
	class="sticky top-0 z-50 transition-all duration-300 backdrop-blur-md bg-[#0a0a0f]/80 border-b border-white/5"
>
	<div class="container mx-auto px-6 max-w-7xl">
		<div class="flex justify-between items-center h-20">
			<!-- Logo -->
			<a
				href="/"
				class="group flex items-center gap-2 font-bold text-2xl text-white tracking-tight"
			>
				<div
					class="relative w-8 h-8 rounded-xl bg-gradient-to-br from-primary to-neon-purple flex items-center justify-center overflow-hidden group-hover:shadow-[0_0_20px_rgba(124,58,237,0.5)] transition-all"
				>
					<span class="text-white text-lg font-mono">OS</span>
				</div>
				<span
					class="bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400"
					>Studio</span
				>
			</a>

			<!-- Desktop Menu -->
			<nav class="hidden md:flex items-center gap-10">
				<a
					href="/how-it-works"
					class="text-sm font-medium text-gray-300 hover:text-white hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.5)] transition-all"
				>
					How It Works
				</a>

				<a
					href="/pricing"
					class="text-sm font-medium text-gray-300 hover:text-white hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.5)] transition-all"
				>
					Pricing
				</a>
				<a
					href="/blog"
					class="text-sm font-medium text-gray-300 hover:text-white hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.5)] transition-all"
				>
					Blog
				</a>
			</nav>

			<!-- CTA Buttons -->
			<div class="hidden md:flex items-center gap-6">
				<a
					href="/login"
					class="text-sm font-medium text-gray-300 hover:text-white transition-colors"
				>
					Sign In
				</a>
				<a
					href="/start"
					class="relative px-6 py-2.5 group overflow-hidden rounded-xl bg-primary hover:bg-primary-dark transition-all duration-300 shadow-[0_0_20px_rgba(124,58,237,0.3)] hover:shadow-[0_0_30px_rgba(124,58,237,0.6)]"
				>
					<div
						class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
					></div>
					<span class="relative text-sm font-semibold text-white"
						>Let's Start</span
					>
				</a>
			</div>

			<!-- Mobile Menu Button -->
			<button
				class="md:hidden p-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-xl transition-colors"
				on:click={toggleMobileMenu}
				aria-label="Toggle menu"
			>
				<svg
					class="w-6 h-6"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d={mobileMenuOpen
							? "M6 18L18 6M6 6l12 12"
							: "M4 6h16M4 12h16M4 18h16"}
					/>
				</svg>
			</button>
		</div>

		<!-- Mobile Menu -->
		{#if mobileMenuOpen}
			<nav
				class="md:hidden pb-6 border-t border-white/5 animate-slide-up bg-[#0a0a0f]"
			>
				<a
					href="/how-it-works"
					class="block py-3 text-gray-300 hover:text-primary transition-colors border-b border-white/5"
				>
					How It Works
				</a>

				<a
					href="/pricing"
					class="block py-3 text-gray-300 hover:text-primary transition-colors border-b border-white/5"
				>
					Pricing
				</a>
				<a
					href="/blog"
					class="block py-3 text-gray-300 hover:text-primary transition-colors border-b border-white/5"
				>
					Blog
				</a>
				<div class="pt-6 flex flex-col gap-4">
					<a
						href="/login"
						class="block text-center py-2 text-gray-300 hover:text-white transition-colors font-medium"
					>
						Sign In
					</a>
					<a
						href="/start"
						class="block px-6 py-3 bg-primary text-white rounded-xl hover:bg-primary-dark transition-colors font-semibold text-center shadow-lg shadow-primary/20"
					>
						Let's Start
					</a>
				</div>
			</nav>
		{/if}
	</div>
</header>
